// Pure seat-picking logic for the altana (no Phaser): which seat to offer, which are taken.
export const SIT_RADIUS = 55;        // feet distance to a seat anchor that offers "Usiądź"
export const CLICK_SIT_RANGE = 170;  // feet distance within which clicking a seat sits you

export function nearestFreeSeat(fx, fy, seats, occupied, radius) {
  let best = null, bestD = radius;
  seats.forEach((s, i) => {
    if (occupied.has(i)) return;
    const d = Math.hypot(fx - s.x, fy - s.y);
    if (d < bestD) { best = i; bestD = d; }
  });
  return best;
}

export function seatsTakenBy(peers) {
  const taken = new Set();
  for (const p of peers) if (p?.mode === 'sit' && Number.isInteger(p.seat)) taken.add(p.seat);
  return taken;
}
